import { render } from "./ProfileModal.vue?vue&type=template&id=153077b2&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "./ProfileModal.vue?vue&type=style&index=0&id=153077b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-153077b2"]])

export default __exports__